import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getCities = ({ zoneId }) => {
  return axios.get(`/addresses/zones/${zoneId}/cities`);
};

export const useCities = ({ zoneId, config } = {}) => {
  return useQuery({
    ...config,
    enabled: !!zoneId,
    queryKey: ["cities", zoneId],
    queryFn: () => getCities({ zoneId }),
    staleTime: Infinity,
    cacheTime: Infinity
  });
};
